import {Box, CircularProgress} from '@mui/material';
import './ai-button.scss';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import {MouseEventHandler} from 'react';

export const AiButton = (props: {
  onClick?: MouseEventHandler<any>;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        width: '40px',
        height: '40px',
        position: 'relative',
        top: '4px',
        marginLeft: '14px',
      }}
    >
      <button
        className="glow-on-hover"
        onClick={(e) => !props.isLoading && !props.disabled && props.onClick && props.onClick(e)}
        disabled={props.disabled}
      >
        {!props.isLoading && <AutoAwesomeIcon />}
        {props.isLoading && (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress
              size={22}
              sx={{
                color: '#fff',
              }}
            />
          </Box>
        )}
      </button>
    </Box>
  );
};
